export default {
  created: {
    notes: 'Created field for recommendations',
    message: 'Created',
  },
  published: {
    notes: 'Title of published field for recommendations',
    message: 'Published',
  },
  topic: {
    notes: 'Title of topic field',
    message: 'Topic',
  },
  state: {
    notes: 'Title of state field (Draft, Published, Completed)',
    message: 'State',
    values: {
      draft: {
        notes: 'State "Draft" for recommendations',
        message: 'Draft',
      },
      published: {
        notes: 'State "Published" for recommendations',
        message: 'Published',
      },
      completed: {
        notes: 'State "Completed" for recommendations',
        message: 'Completed',
      },
    },
  },
  importance: {
    notes: 'Title of criticality field (Normal, High, Urgent)',
    message: 'Importance',
    values: {
      normal: {
        notes: 'Criticality "Normal" for recommendations',
        message: 'Normal',
      },
      high: {
        notes: 'Criticality "High" for recommendations',
        message: 'High',
      },
      urgent: {
        notes: 'Criticality "Urgent" for recommendations',
        message: 'Urgent',
      },
    },
  },
  creator: {
    notes: 'Creator field for recommendations',
    message: 'Creator',
  },
  recommendedToCompany: {
    notes: 'Recommended to company field',
    message: 'Company',
  },
  assignedToUser: {
    notes: 'Assigned to user field for recommendations',
    message: 'Assigned to',
  },
  orderedStatus: {
    notes: 'Ordered status field for recommendations (Open, Partial, Ordered)',
    message: 'Ordered',
    values: {
      draft: {
        notes:
          'Status "Draft" for recommendations ordered. This is used when there are no items.',
        message: '-',
      },
      open: {
        notes: 'Status "Open" for recommendations',
        message: 'Open',
      },
      ordered: {
        notes: 'Status "Ordered" for recommendations',
        message: 'Ordered',
      },
      partial: {
        notes: 'Status "Partial" for recommendations',
        message: 'Partial',
      },
    },
  },
  equipment: {
    notes: 'Equipment (tagged to) field for recommendations',
    message: 'Equipment',
  },
  items: {
    notes: 'Items field for recommendations',
    message: 'Items',
  },
  messageField: {
    notes: 'Title of message field (technical name "description"',
    message: 'Message',
  },
};
